var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audio",attrs:{"controls":"controls","hidden":"","src":require("@/assets/sounds/notify.wav")}})
}
var staticRenderFns = []

export { render, staticRenderFns }